export const languages = [
  { label: "Afrikaans", value: "afr", code: "af" },
  { label: "Albanian", value: "sqi", code: "sq" },
  { label: "Amharic", value: "amh" },
  { label: "Arabic", value: "ara", code: "ar" },
  { label: "Armenian", value: "hye" },
  { label: "Azerbaijani", value: "aze", code: "az" },
  { label: "Basque", value: "eus" },
  { label: "Belarusian", value: "bel" },
  { label: "Bengali", value: "ben", code: "bn" },
  { label: "Bosnian", value: "bos" },
  { label: "Bulgarian", value: "bul", code: "bg" },
  { label: "Burmese", value: "mya" },
  { label: "Catalan", value: "cat", code: "ca" },
  { label: "Chinese", value: "zho", code: "zh_CN" },
  { label: "Croatian", value: "hrv", code: "hr" },
  { label: "Czech", value: "ces", code: "cs" },
  { label: "Danish", value: "dan", code: "da" },
  { label: "Dutch", value: "nld", code: "nl" },
  { label: "English", value: "eng", code: "en" },
  { label: "Estonian", value: "est", code: "et" },
  { label: "Filipino", value: "fil", code: "fil" },
  { label: "Finnish", value: "fin", code: "fi" },
  { label: "French", value: "fra", code: "fr" },
  { label: "Galician", value: "glg" },
  { label: "Georgian", value: "kat", code: "ka" },
  { label: "German", value: "deu", code: "de" },
  { label: "Greek", value: "ell", code: "el" },
  { label: "Gujarati", value: "guj", code: "gu" },
  { label: "Hebrew", value: "heb", code: "he" },
  { label: "Hindi (India)", value: "hin", code: "hi" },
  { label: "Hungarian (Hungary)", value: "hun", code: "hu" },
  { label: "Icelandic", value: "isl" },
  { label: "Indonesian", value: "ind", code: "id" },
  { label: "Irish", value: "gle", code: "ga" },
  { label: "Italian", value: "ita", code: "it" },
  { label: "Japanese", value: "jpn", code: "ja" },
  { label: "Kannada", value: "kan", code: "kn" },
  { label: "Kazakh", value: "kaz", code: "kk" },
  { label: "Khmer", value: "khm" },
  { label: "Korean", value: "kor", code: "ko" },
  { label: "Kyrgyz", value: "kir", code: "ky_KG" },
  { label: "Lao", value: "lao", code: "lo" },
  { label: "Latvian", value: "lav", code: "lv" },
  { label: "Lithuanian", value: "lit", code: "lt" },
  { label: "Macedonian", value: "mkd", code: "mk" },
  { label: "Malay", value: "msa", code: "ms" },
  { label: "Malayalam", value: "mal", code: "ml" },
  { label: "Maltese", value: "mlt" },
  { label: "Marathi", value: "mar", code: "mr" },
  { label: "Mongolian", value: "mon" },
  { label: "Nepali", value: "nep" },
  { label: "Norwegian", value: "nor", code: "nb" },
  { label: "Pashto", value: "pus" },
  { label: "Persian", value: "fas", code: "fa" },
  { label: "Polish", value: "pol", code: "pl" },
  { label: "Portuguese", value: "por", code: "pt_BR" },
  { label: "Punjabi", value: "pan", code: "pa" },
  { label: "Romanian", value: "ron", code: "ro" },
  { label: "Russian", value: "rus", code: "ru" },
  { label: "Serbian", value: "srp", code: "sr" },
  { label: "Sinhala", value: "sin" },
  { label: "Slovak", value: "slk", code: "sk" },
  { label: "Slovenian", value: "slv", code: "sl" },
  { label: "Somali", value: "som" },
  { label: "Spanish", value: "spa", code: "es" },
  { label: "Swahili", value: "swa", code: "sw" },
  { label: "Swedish", value: "swe", code: "sv" },
  { label: "Tagalog", value: "tgl" },
  { label: "Tamil", value: "tam", code: "ta" },
  { label: "Telugu", value: "tel", code: "te" },
  { label: "Thai", value: "tha", code: "th" },
  { label: "Turkish", value: "tur", code: "tr" },
  { label: "Ukrainian", value: "ukr", code: "uk" },
  { label: "Urdu", value: "urd", code: "ur" },
  { label: "Uzbek", value: "uzb", code: "uz" },
  { label: "Vietnamese", value: "vie", code: "vi" },
  { label: "Welsh", value: "cym" },
  { label: "Xhosa", value: "xho" },
  { label: "Yiddish", value: "yid" },
  { label: "Zulu", value: "zul", code: "zu" },
] as const

export type Language = typeof languages[number]
export type LanguageValue = Language["value"]
export type LanguageLabel = Language["label"]
